var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"p-12 bg-gray-200 min-h-screen"},[_vm._v("Verifying ...")])
}
var staticRenderFns = []

export { render, staticRenderFns }